<template>
    <div class="container">
        <div v-if="!order">
            <div class="order-details-header">
                <van-skeleton title  :row="1" />
                <br>
            </div>
            <div class="order-logistics-card card card-cover">
                <van-skeleton title  :row="2" />
                <br>
                <van-skeleton title  :row="2" />
            </div>
            <div class="card card-cover goods">
                <van-skeleton  title avatar avatar-shape="square" :avatar-size="80" :row="2" />
                <br>
                <van-skeleton  title avatar avatar-shape="square" :avatar-size="80" :row="2" />
            </div>
            <div class="card card-cover" style="text-align: center;">
                <van-skeleton  :row="1" />
            </div>
            <div class="card  card-cover">
                <van-skeleton  :row="2" />
                <br>
                <br>
                <van-skeleton  :row="2" />
                <br>
                <br>
                <van-skeleton  :row="2" />
            </div>
        </div>

        <div v-else>


            <!--<van-nav-bar
                    title="订单详情"
                    left-arrow
                    :fixed="true"
                    class="my-nav"
                    @click-left="$router.back(-1)"
            />-->
            <div class="order-details-header">
                <div class="order-status" v-text="order.order_status">
                    等待收货
                </div>
                <div class="order-logistics-tip" v-if="order.tips" v-html="order.tips">

                </div>

            </div>
            <div class="order-logistics-card card card-cover">
                <van-cell v-if="order.logistics" center icon="logistics" :title="order.logistics.context" :label="order.logistics.time" is-link="true" :url="'/#/logistics?orderNo='+order.order_number"/>

                <van-cell center icon="location-o" :title="order.receiver+'  '+order.mobile_phone"
                          :label="'地址：'+order.address"/>
            </div>

            <div class="card card-cover goods">
                <div class="shop">
                    <van-icon name="shop-o" style="margin-right: 5px"/>
                    <span v-text="order.shopName">山东德恩怡华通信科技有限公司</span>
                </div>
                <van-card v-for="g in order.goods"
                          :num="g.count"
                          :price="g.price"
                          :desc="g.standard"
                          :title="g.title"
                          class="goods-card"
                          :thumb="g.thumb"
                >
                   <!-- <template #footer>
                        <van-button size="mini">加购物车</van-button>
                    </template>-->
                </van-card>


            </div>

            <div class="card" style="text-align: center">
                <van-icon name="chat-o"/>
                联系客服
            </div>

            <div class="card  oder-info">
                <ul class="order-info-list">
                    <li><small>订单编号:</small> <span v-text="order.order_number">111</span></li>
                    <li><small>下单时间:</small> <span v-text="order.order_time"></span></li>
                    <br>
                    <li><small>支付方式:</small> <span v-text="order.payment_method"></span></li>
                    <li><small>支付时间:</small> <span v-text="order.payment_time"></span></li>
                    <br>
                    <li v-if="order.logistics"><small>配送方式:</small> <span v-text="order.logistics.name"></span></li>
                    <li v-if="order.logistics"><small>物流单号:</small> <span v-text="order.logistics.no"></span></li>
                </ul>
                <div class="price-warpper">
                    <div class="prices">
                        <div class="name">商品总额</div>
                        <div class="price" v-text="'￥'+order.total_price">￥69.00</div>
                    </div>
                    <div class="prices">
                        <div class="name">运费</div>
                        <div class="price" v-text="'￥'+order.freight">￥6.00</div>
                    </div>
                    <div class="total-price">
                        <small>实付款：</small> <span style="color: #ff3333"
                                                  v-text="'￥'+order.actually_total_price">￥75.00</span>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import {orderDetail} from '../../api/order'

    export default {
        name: "order-detail",
        data() {
            return {
                order: {
                    "code": 0,
                    "message": "OK",
                    "order_status": "已付款",
                    "order_number": "20201123085815797da0766",
                    "order_time": "2020-11-23 08:58:17",
                    "payment_time": "2020-11-23 08:58:21",
                    "delivery_time": "——",
                    "payment_method": "线上支付",
                    "receiver": "测试用不发货",
                    "mobile_phone": "18769727652",
                    "address": "山东省 济南市 天桥区 null 测试不发货333",
                    "goods": [{
                        "thumb": "http://image-jinyijia1688-com.oss-cn-beijing.aliyuncs.com/goods_0547a2c2643e6576cd8c39f3ea86b357.jpg",
                        "title": "技术测试",
                        "standard": "熔岩红/融合产品",
                        "goods_number": "5906",
                        "price": 1200.0,
                        "count": 1
                    }],
                    tips:'顺丰 | 预计两日内送达',
                    logistics:{
                      name:'顺丰',
                      context:'您的订单已经到达京东【xxxx】',
                      time:'2020-11-23 15:01:23',
                       no:'xxxxxxx'
                    },
                    "total_price": 1200.0,
                    "freight": 0.0,
                    "actually_total_price": 1200.0,
                    "shopName": "山东德恩怡华通信科技有限公司"
                }
            }
        },
        mounted() {
            this.order = undefined
            orderDetail(this.$route.query, d => {
                if (d) {
                    this.order = d
                }
            })

        },
        methods: {
            formatPrice(price) {
                return (price).toFixed(2);
            }
        }
    }
</script>

<style scoped lang="less">
    .container {
        min-height: 100%;
        background: #eee;
    }

    .loading {
        padding-top: 200px;
        background: #eee;
        text-align: center;
    }

    .order-details-header {
        padding: 20px;
        color: #fff;
        background: linear-gradient(to top left, #ff3333, #ff4444, #ff7777);
        min-height: 46px;
        text-align: center;
        font-size: 14px;

        .order-status {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 20px;
        }

        .order-logistics-tip {
            margin-bottom: 20px;
        }
    }

    .card {
        margin-top: 10px;
        margin-bottom: 10px;
        padding: 15px;
        font-size: 12px;
        background: #fff;
        border-radius: 10px;
    }

    .card-cover {
        padding: 10px 0;
    }

    .order-logistics-card {
        margin-top: -15px;

        .address {
            padding: 15px;
        }
    }

    .shop {
        margin-left: 10px;
        padding: 5px;
    }

    .goods-footer {
        padding: 15px 15px 0;
        display: flex;
        justify-content: flex-end;
    }

    .oder-info {
        padding: 15px;
        font-size: 12px;

        .order-info-list {
            li {
                margin-bottom: 15px;

                small {
                    color: #666;
                    margin-right: 10px;
                }
            }
        }

        .price-warpper {
            margin-top: 30px;
        }

        .prices {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;

            .name {
                color: #666;
            }
        }

        .total-price {
            font-size: 14px;
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
        }
    }
</style>

<style lang="less">
    .van-cell {
        font-size: 12px;
    }

    .van-card__footer {
        .van-button {
            border-radius: 15px;
            padding: 5px 10px;
        }
    }
</style>
